import Textfield from "../../../common/components/Textfiled.jsx";
import Select from "../../../common/components/Select.jsx";
import Textarea from "../../../common/components/Textareafield.jsx";
import { Col } from "react-bootstrap";
import { usePlatesVehiclesQuery } from "../hooks/usePlatesVehiclesQuery.js";

const OPTIONS = [
  { label: "Preventivo", value: "preventivo" },
  { label: "Correctivo", value: "correctivo" },
];

function FormMaintenance({
  maintenance,
  onChange,
  onSubmit,
  onCancel,
  errors,
  submitLabel = "Guardar",
  loading = false,
}) {
  const { plates } = usePlatesVehiclesQuery({ status: "Activo" });
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit} className="row row-cols-1 row-cols-md-2 g-3">
      <Col>
        <Select
          options={plates.map((plate) => ({
            label: plate.plate,
            value: plate.plate,
          }))}
          label="Placa del vehiculo"
          placeholder="Placa del vehiculo"
          name="plate"
          value={maintenance.plate}
          onChange={onChange}
          error={errors?.plate}
        />
      </Col>
      <Col>
        <Select
          label="Tipo de mantenimiento"
          options={OPTIONS}
          name="type"
          onChange={onChange}
          value={maintenance.type}
          error={errors?.type}
        />
      </Col>

      <Col>
        <Textfield
          label="Fecha de mantenimiento"
          type="date"
          name="date"
          value={maintenance.date}
          onChange={onChange}
          error={errors?.date}
        />
      </Col>
      <Col>
        <Textfield
          label="Kilometraje"
          type="number"
          placeholder="Kilometraje"
          name="mileage"
          value={maintenance.mileage}
          onChange={onChange}
          error={errors?.mileage}
        />
      </Col>

      <Col>
        <Textarea
          label="Observaciones"
          placeholder="Observaciones"
          name="observations"
          value={maintenance.observations || ""}
          onChange={onChange}
          error={errors?.observations}
        />
      </Col>
      {maintenance.type === "preventivo" && (
        <Col>
          <Textfield
            label="Siguiente mantenimiento preventivo"
            type="date"
            name="nextPreventiveMaintenance"
            value={maintenance.nextPreventiveMaintenance || ""}
            onChange={onChange}
            error={errors?.nextPreventiveMaintenance}
          />
        </Col>
      )}

      <Col>
        <Textfield
          label="Número de factura"
          placeholder="Numero de factura"
          name="numberInvoice"
          value={maintenance.numberInvoice}
          onChange={onChange}
          error={errors?.numberInvoice}
        />
      </Col>
      <Col>
        <Textfield
          label="Proveedor"
          placeholder="Proveedor"
          name="provider"
          value={maintenance.provider}
          onChange={onChange}
          error={errors?.provider}
        />
      </Col>

      <Col>
        <Textfield
          label="Valor de la factura"
          type="number"
          placeholder="Valor de la factura"
          name="valueInvoice"
          value={maintenance.valueInvoice}
          onChange={onChange}
          error={errors?.valueInvoice}
        />
      </Col>
      <Col>
        <Textfield
          label="Nombre del responsable"
          placeholder="Nombre del responsable"
          name="nameManager"
          value={maintenance.nameManager}
          onChange={onChange}
          error={errors?.nameManager}
        />
      </Col>

      <Col>
        <Textfield
          label="Identificación del responsable"
          placeholder="Identificación del responsable"
          name="identificationManager"
          value={maintenance.identificationManager}
          onChange={onChange}
          error={errors?.identificationManager}
        />
      </Col>
      <Col>
        <Textfield
          label="Rol del responsable"
          placeholder="Rol del responsable"
          name="roleManager"
          value={maintenance.roleManager}
          onChange={onChange}
          error={errors?.roleManager}
        />
      </Col>

      <Col>
        <Textfield
          label="NIT del establecimiento"
          placeholder="NIT del establecimiento"
          name="nitCompany"
          value={maintenance.nitCompany}
          onChange={onChange}
          error={errors?.nitCompany}
        />
      </Col>
      <Col>
        <Textfield
          label="Dirección del establecimiento"
          placeholder="Dirección del establecimiento"
          name="addressCompany"
          value={maintenance.addressCompany}
          onChange={onChange}
          error={errors?.addressCompany}
        />
      </Col>

      <Col xs={12} className="d-flex justify-content-end gap-2 mt-2">
        {onCancel && (
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onCancel}
            disabled={loading}
          >
            Cancelar
          </button>
        )}
        <button type="submit" className="btn btn-dark" disabled={loading}>
          {loading ? "Cargando..." : submitLabel}
        </button>
      </Col>
    </form>
  );
}

export default FormMaintenance;
